import store from 'src/store'
import { wp, ws } from 'src/services'

export default [
  {
    id: 'E01',
    name: `Registro de pontos de todos os ${wp('employee')}`,
    dateSelecion: ['period'],
    filters: ['company', 'employer'],
    description: 'Direcionado para exportação dos dados do PontoTel para o Software de folha de pagamento. ' +
      `Arquivo com os registros de ponto do ${ws('employee')} no período selecionado, junto com o número do PIS.`,
    show: true
  },
  {
    id: 'E02',
    name: 'Arquivo para importação de apontamentos',
    dateSelecion: ['month'],
    filters: ['company', 'employer', 'employee'],
    description: 'Relatório tipo TXT ou CSV para importação em sistemas de pagamento, por padrão não configurado. ' +
      'Favor entre em contato, caso precise configurar uma exportação.',
    show: true
  },
  {
    id: 'E03',
    name: 'Arquivo para importação de banco de horas',
    filters: ['company', 'employee'],
    description: '',
    show: store.state.userInfo.compMan.hasWhbank
  },
  {
    id: 'E04',
    name: `Áudio e imagem dos pontos dos ${wp('employee')}`,
    dateSelecion: ['period'],
    filters: ['company', 'employee'],
    description: `Relatório com todos os pontos batidos dos ${wp('employee')} durante o mês`,
    show: true
  },
  {
    id: 'E05',
    name: `Arquivo AFD com os pontos dos ${wp('employee')}`,
    dateSelecion: ['period'],
    filters: ['company', 'employer'],
    description: `Relatório com todos os pontos batidos dos ${wp('employee')} durante o mês`,
    show: true
  },
  {
    id: 'E06',
    name: `Arquivo AFDT com os pontos dos ${wp('employee')}`,
    dateSelecion: ['period'],
    filters: ['company', 'employer'],
    description: `Relatório com todos os pontos batidos dos ${wp('employee')} durante o mês`,
    show: true
  },
  {
    id: 'E07',
    name: `Arquivo ACJEF com os pontos dos ${wp('employee')}`,
    dateSelecion: ['period'],
    filters: ['company', 'employer'],
    description: '',
    show: true
  },
  {
    id: 'E08',
    name: 'Arquivo para importação de histórico',
    dateSelecion: ['month'],
    filters: ['company', 'employer', 'employee'],
    description: 'Relatório tipo .txt ou .csv para importação em sistemas de pagamento, Por padrão não configurado, favor entre em contato se você precisa configurar a exportação',
    show: true
  },
  {
    id: 'E09',
    name: 'Arquivo para com detalhamento de apontamentos',
    dateSelecion: ['month'],
    filters: ['company', 'employer', 'employee', 'userGroup'],
    description: 'Relatório tipo .csv para importação em sistemas internos',
    show: true
  }
]
